import axios from 'axios';
import React, { useState } from 'react'
import { useNavigate ,Link} from 'react-router-dom';
import { Helmet } from 'react-helmet';
//import styles from '../../Business.css';
//import banner from '../../images/banners/client.jpg'
import banner from '../../../images/banners/client.jpg'
export default function Wallet_dashsignin() {

    const INTEGRA_URL = process.env.REACT_APP_INTEGRA_URL;
    const navigate = useNavigate();
    const [parcels, setparcels] = useState()
    const [sendpath, setsendpath] = useState()
    const [loggeduser, setloggeduser] = useState({
        username: "",
        password: ""
    })

      function dashboardLogin(){
        const API_PATH=`${INTEGRA_URL}dashboard_wallet_login.php`;
        if(loggeduser.username !="" && loggeduser.password !=""){
           
            axios({
                method: 'post',
                url: `${API_PATH}`,
                data: loggeduser
            })
            .then((res)=>
            {
               console.log(res.data)
                if(res.data>0){
                    console.log('dashboard'+res.data)

                    sessionStorage.setItem('adminno',res.data);
                  navigate('/wallet-dashboard')
               
                 }else{
                     alert("password missmatch")
                 }
            }
            )
            .catch((err)=>console.log(err))

        }else{
            console.log("Enter username and password")
        }

      }
    return (
        <div className="clientzone">

<Helmet>
        <title>Time Express | Admin Wallet Signin</title>
      </Helmet>
            <section className="your_business_page fw" style={{ backgroundImage:  `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 your_business text-center client_zone">
                            <div className="business_content"  style={{display: "none"}}>
                               
                                <h1 className='h1-title'>Wallet Admin Dashboard</h1></div>
                            <div className="container">
                                <div className="row" style={{display: "ruby"}}>

                                    
                                    <div className="col-md-5" style={{ border: "1px solid", marginTop: "6%", marginBottom: "6%", background: "#fff" }}>
                                        <div id="primary" className="content-area" style={{ float: 'left', padding: '3%', width: "100%" }}>
                                            <h3 style={{ textTransform: "uppercase", padding: "3%" }}><span>Wallet Admin Dashboard</span></h3>
                                            {sessionStorage.getItem('adminno')?(
                                            <p>Please <Link to="/wallet-dashboard">click</Link> here to view the dashboard</p>
                                            ):
                                            ( <main id="main" className="site-main" role="main">
                                            <form>
                                                <input type="text" placeholder='username' className="form-control mb-3" required onChange={(e) => setloggeduser({ ...loggeduser, username: e.target.value })} />
                                                <input type="text" placeholder='password' className="form-control  mb-3" required onChange={(e) => setloggeduser({ ...loggeduser, password: e.target.value })} />
                                                <button type="button" onClick={dashboardLogin} className="btn  btn-sm" style={{ backgroundColor: '#7b3995', color: "#fff", padding: "2%", width: "19%" }}>Login</button>
                                            </form>
                                        </main>)
                                        }
                                           
                                        </div>
                                    </div>

                                </div>
                            </div>





                        </div>
                    </div>
                </div>


            </section>

        </div>
    )
}
